import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Api from "../../utils/api";
import { toast } from "react-toastify";

const HeaderBannerCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    page: "product",
    first_bg_color: "#000000",
    first_txt_color: "#ffffff",
    blinked: false,
    second_bg_color: "#ffff00",
    second_txt_color: "#ff0000",
    text: "",
    banner_link: "",
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    new Api()
      .post("/header-banner/store", formData, false)
      .then((response) => {
        if (response && response.status) {
          toast.success(response.msg);

          navigate("/header-banner");
        } else if (!response.status) {
          toast.error(response.msg);
        }
        setLoading(false);
      })
      .catch((response) => {
        setLoading(false);
      });
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
        <Typography variant="h4">افزودن بنر هدر جدید</Typography>
      </div>

      <Card>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>صفحه</InputLabel>
                  <Select
                    value={formData.page}
                    onChange={(e) => handleInputChange("page", e.target.value)}
                  >
                    <MenuItem value="product">محصولات</MenuItem>
                    <MenuItem value="blog">بلاگ</MenuItem>
                    <MenuItem value="landing">صفحه اصلی</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  margin="normal"
                  label="متن بنر"
                  value={formData.text}
                  onChange={(e) => handleInputChange("text", e.target.value)}
                  required
                />

                <TextField
                  fullWidth
                  margin="normal"
                  label="لینک بنر"
                  value={formData.banner_link}
                  onChange={(e) =>
                    handleInputChange("banner_link", e.target.value)
                  }
                />

                <Grid container spacing={2} style={{ marginTop: 16 }}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="color"
                      label="رنگ پس‌زمینه اول"
                      value={formData.first_bg_color}
                      onChange={(e) =>
                        handleInputChange("first_bg_color", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="color"
                      label="رنگ متن اول"
                      value={formData.first_txt_color}
                      onChange={(e) =>
                        handleInputChange("first_txt_color", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} style={{ marginTop: 8 }}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="color"
                      label="رنگ پس‌زمینه دوم"
                      value={formData.second_bg_color}
                      onChange={(e) =>
                        handleInputChange("second_bg_color", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="color"
                      label="رنگ متن دوم"
                      value={formData.second_txt_color}
                      onChange={(e) =>
                        handleInputChange("second_txt_color", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.blinked}
                      onChange={(e) =>
                        handleInputChange("blinked", e.target.checked)
                      }
                    />
                  }
                  label="چشمک زن"
                  style={{ marginTop: 16 }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography variant="h6" gutterBottom>
                  پیش‌نمایش
                </Typography>
                <Box p={2} border={1} borderColor="grey.300" borderRadius={4}>
                  <div
                    style={{
                      backgroundColor: formData.first_bg_color,
                      color: formData.first_txt_color,
                      padding: "8px 16px",
                      textAlign: "center",
                      animation: formData.blinked
                        ? "blink 1s linear infinite"
                        : "none",
                    }}
                  >
                    {formData.text || "متن بنر شما اینجا نمایش داده می‌شود"}
                  </div>
                </Box>
              </Grid>
            </Grid>

            <Box mt={3} display="flex" justifyContent="flex-end">
              <Button
                type="button"
                onClick={() => navigate("/header-banner")}
                style={{ marginRight: 16 }}
              >
                انصراف
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                {loading ? "در حال ذخیره..." : "ذخیره بنر"}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>

      <style jsx>{`
        @keyframes blink {
          0%,
          50% {
            opacity: 1;
          }
          51%,
          100% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default HeaderBannerCreate;
